import { useSyncExternalStore } from 'react'

export const CALLBACK_TIMEOUT_MS = 10 * 60 * 1000
let snapshot = { state: 'idle', startedAt: 0 }
const subscribers = new Set()

export function setNativeCallbackState(state, extra = {}) {
  snapshot = { ...snapshot, state, ...extra }
  subscribers.forEach((subscriber) => subscriber())
}

export function getNativeCallbackState() { return snapshot }

export function useNativeCallbackState() {
  return useSyncExternalStore(
    (subscriber) => { subscribers.add(subscriber); return () => subscribers.delete(subscriber) },
    getNativeCallbackState,
    getNativeCallbackState,
  )
}

export function validateMembersCallback(rawUrl) {
  try {
    const parsed = new URL(rawUrl)
    return parsed.protocol === 'com.privana.members:' &&
      parsed.hostname.toLowerCase() === 'dev-fcv2y3k6q4jfmx5k.us.auth0.com' &&
      parsed.pathname === '/capacitor/com.privana.members/callback' &&
      parsed.searchParams.has('state') &&
      (parsed.searchParams.has('code') || parsed.searchParams.has('error'))
  } catch { return false }
}

export function isNativeCallbackPending() {
  return snapshot.state === 'awaiting_callback' || snapshot.state === 'processing_callback'
}
